module.exports = __webpack_public_path__ + "img/sf1.a7506469.png";